import React from 'react';
import  Feature  from '../../components/feature/Feature';
import './whatGPT3.css';


const WhatGPT3 = () => {
    return (
      <div className='gpt3__whatgpt3 section__margin' id='wgpt3'>
        <div className='gpt3__whatgpt3-feature'>
          <Feature title='¿Que es GPT-3?' text='Así que opinamos que mis amigos me envían un mensaje como un deleite. Todo el frente de la placa se escuchó oh debería. Su residencia defectuosa ni convencida propia. La conexión ha puesto los propios apartamentos imposibles bulliciosos. En el empalme, la señora insistió en que la humanidad él. Amistosa entrada de soltero a on by.'/>   
        </div>
        <div className='gpt3__whatgpt3-heading'>
          <h1 className='gradient__text'>Las posibilidades están más allá de tu imaginación</h1>
          <p>Explora La Biblioteca</p>
        </div>
        <div className='gpt3__whatgpt3-container'>
          <Feature title='Chatbots' text='Así que opinamos que mis amigos me envían un mensaje como un deleite. Todo el frente de la placa se escuchó oh debería. '/>
          <Feature title='Base de conocimientos' text='En el empalme, la señora insistió en que la humanidad él. Amistosa entrada de soltero a on by. Como poner apartamentos propios imposibles b'/>
          <Feature title='Educación' text='En el empalme, la señora insistió en que la humanidad él. Amistosa entrada de soltero a on by. Como poner apartamentos propios imposibles b'/>
        </div>
      </div>
    )
  }
  
  export default WhatGPT3;